import React, { useId, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { truncateFileName } from "utils/pageContentUtils"

/**
 * File input with translated button and status text (replaces browser defaults).
 * Long file names are truncated with an ellipsis while keeping the extension.
 */
const TranslatedFileInput = ({
  id: idProp,
  name,
  className = "",
  accept,
  disabled = false,
  multiple = false,
  onChange,
  invalid = false,
  statusText,
}) => {
  const { t } = useTranslation()
  const generatedId = useId()
  const inputId = idProp || generatedId
  const inputRef = useRef(null)
  const [fileLabel, setFileLabel] = useState("")
  const [fullFileName, setFullFileName] = useState("")

  const handleChange = e => {
    onChange?.(e)
    const files = e.target.files
    const count = files?.length ?? 0
    if (!count) {
      setFullFileName("")
      setFileLabel("")
      return
    }
    if (multiple && count > 1) {
      setFullFileName("")
      setFileLabel(t("{{count}} files selected", { count }))
      return
    }
    const nameValue = files[0]?.name || ""
    setFullFileName(nameValue)
    setFileLabel(nameValue ? truncateFileName(nameValue) : "")
  }

  return (
    <div
      className={`translated-file-input d-flex align-items-center flex-wrap gap-2 ${className}`}
    >
      <input
        ref={inputRef}
        type="file"
        id={inputId}
        name={name}
        className="d-none"
        accept={accept}
        disabled={disabled}
        multiple={multiple}
        onChange={handleChange}
      />
      <button
        type="button"
        className={`btn btn-outline-secondary btn-sm ${
          invalid ? "border-danger" : ""
        }`}
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
      >
        {t("Choose File")}
      </button>
      <span
        className="text-muted small translated-file-name"
        title={fullFileName || undefined}
      >
        {fileLabel || statusText || t("No file chosen")}
      </span>
    </div>
  )
}

export default TranslatedFileInput
